<template>
  <div class="ota-wrapper">
    <!-- 🧩 APP DE MENSAJES NO INSTALADA -->
    <div v-if="messagesAppNotInstalled" class="ota-app-card">
      <div class="ota-app-content">
        <div class="ota-app-text">
          <h4 class="ota-app-title">{{ $t('reservasPanels.ota.appTitle') }}</h4>
          <p class="ota-app-subtitle">
            {{ $t('reservasPanels.ota.installIntro') }}
            <strong>Channex Messages</strong> {{ $t('reservasPanels.ota.installIntroTail') }}
          </p>
        </div>
      </div>
      <div class="ota-app-actions">
        <Button
          class="btn wa-btn-green ota-app-main-btn"
          @click="installMessagesApp"
          :disabled="installingApp"
        >
          <span v-if="!installingApp">{{ $t('reservasPanels.ota.installBtn') }}</span>
          <span v-else>{{ $t('reservasPanels.ota.installing') }}</span>
        </Button>
        <button type="button" class="ota-app-link" @click="retryAfterInstall">
          {{ $t('reservasPanels.ota.retryLink') }}
        </button>
      </div>
    </div>

    <!-- 💬 CHAT OTA NORMAL -->
    <div v-else class="ota-chat-panel">
      <div v-if="loadingMessages" class="ota-loading">
        {{ $t('reservasPanels.ota.loading') }}
      </div>

      <div v-else class="ota-chat">
        <!-- MENSAJES -->
        <div class="ota-messages" :class="{ 'ota-messages--booking': isBooking, 'ota-messages--airbnb': isAirbnb }" ref="otaContainer">
          <div v-if="!messages.length" class="ota-empty">
            {{ $t('reservasPanels.ota.empty') }}
          </div>

          <div
            v-for="msg in messages"
            :key="msg.id"
            class="ota-message-row"
            :class="msg.sender"
          >
            <div class="ota-message-card" :class="msg.sender">
              <MessageTranslate
                v-if="msg.message"
                class="ota-message-text"
                :text="msg.message"
                :property-id="property && property.id"
                :translation="tradDe(msg.id)"
              />

              <!-- ✅ ATTACHMENTS: preview si es imagen, link si no — Vue 2 compatible -->
              <div
                v-if="msg.attachments && msg.attachments.length"
                class="ota-attachments"
              >
                <div
                  v-for="(att, idx) in msg.attachments"
                  :key="idx"
                  class="ota-attachment-item"
                  v-html="renderAttachment(att)"
                  @click.prevent="handleAttachmentClick(att)"
                ></div>
              </div>

              <div class="ota-meta">
                <span class="ota-sender">{{ formatSender(msg.sender) }}</span>
                <span class="ota-date">{{ formatDate(msg.inserted_at) }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- ✍️ FOOTER CON SWITCH Y COMPOSER -->
        <div class="ota-footer">
          <div class="mode-toggle">
            <span class="mode-label mode-label--ai" :class="{ active: !isManualMode }">
              <svg class="ai-agent-icon ai-agent-icon--sm" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M20.006 15.344a.544.544 0 0 0-1.012 0l-.946 2.398a.54.54 0 0 1-.306.306l-2.398.946a.544.544 0 0 0 0 1.012l2.398.946c.14.055.251.166.306.306l.946 2.398c.181.459.83.459 1.012 0l.946-2.398a.54.54 0 0 1 .306-.306l2.398-.946a.544.544 0 0 0 0-1.012l-2.398-.946a.54.54 0 0 1-.306-.306z" />
                <path fill="currentColor" d="M12 .125a1 1 0 0 1 1 1v2.48c0 .112 0 .169.029.208q.014.02.033.033c.04.029.096.029.208.029h.005c1.665 0 2.994-.001 4.052.113 1.077.117 1.99.364 2.78.938a5.5 5.5 0 0 1 1.217 1.217c.574.79.821 1.703.938 2.78.114 1.058.113 2.387.113 4.052v.3q0 .661-.002 1.253c-.003.441-.004.662-.087.703a.15.15 0 0 1-.08.015c-.092-.009-.175-.218-.34-.636l-.085-.195a2.47 2.47 0 0 0-1.243-1.2c-.066-.03-.1-.044-.12-.064a.14.14 0 0 1-.032-.05c-.011-.026-.011-.06-.011-.126 0-1.71-.001-2.911-.102-3.836-.098-.907-.28-1.429-.566-1.822a3.5 3.5 0 0 0-.774-.774c-.393-.285-.915-.468-1.822-.566-.925-.1-2.126-.102-3.836-.102h-2.55c-1.71 0-2.911.001-3.836.102-.907.098-1.43.28-1.822.566a3.5 3.5 0 0 0-.774.774c-.285.393-.468.915-.566 1.822-.1.925-.102 2.126-.102 3.836v.3c0 1.71.001 2.911.102 3.836.098.907.28 1.43.566 1.822a3.5 3.5 0 0 0 .774.774c.393.285.915.468 1.822.566.925.1 2.126.102 3.836.102h2.236c.08 0 .12 0 .152.016q.015.006.029.019c.027.022.045.062.08.142.25.564.713 1.048 1.388 1.314.418.165.627.248.636.34a.15.15 0 0 1-.015.08c-.041.083-.262.084-.703.087q-.592.003-1.253.002h-2.55c-1.665 0-2.994.001-4.052-.113-1.077-.117-1.99-.364-2.78-.938a5.5 5.5 0 0 1-1.217-1.217c-.574-.79-.821-1.703-.938-2.78-.114-1.058-.113-2.387-.113-4.052v-.3c0-1.665-.001-2.994.113-4.052.117-1.077.364-1.99.938-2.78a5.5 5.5 0 0 1 1.217-1.217c.79-.574 1.703-.821 2.78-.938 1.058-.114 2.387-.113 4.052-.113h.005c.112 0 .169 0 .208-.029a.2.2 0 0 0 .033-.033c.029-.04.029-.096.029-.208v-2.48a1 1 0 0 1 1-1" />
                <path fill="currentColor" d="M8.25 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M15.75 11.25a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3" />
              </svg>
              {{ $t('reservasPanels.ota.modeAi') }}
            </span>
            <InputSwitch v-model="isManualMode" @change="handleModeChange" class="custom-switch" />
            <span class="mode-label mode-label--manual" :class="{ active: isManualMode }">
              <svg class="ai-agent-icon ai-agent-icon--sm" viewBox="0 0 24 24" aria-hidden="true">
                <path fill="currentColor" d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-5.33 0-8 2.67-8 4v1h16v-1c0-1.33-2.67-4-8-4z"/>
              </svg>
              {{ $t('reservasPanels.ota.modeManual') }}
            </span>
            <!-- El traductor, en la misma fila que el IA/Manual: no gasta un renglón
                 propio encima de la caja. La previa sigue encima de la caja. -->
            <BarraTraduccion
              v-if="isManualMode"
              parte="interruptor"
              :activo="trad.activo"
              :idioma-huesped="trad.idiomaHuesped"
              :nombre-huesped="trad.idiomaHuesped ? tradNombreDe(trad.idiomaHuesped) : ''"
              :mi-idioma-nombre="tradMiIdiomaNombre"
              :salida="tradSalida"
              :opciones="tradOpciones"
              :hay-que-leer="tradHayQueLeer"
              :hay-que-enviar="tradHayQueEnviar"
              :previa="trad.previa"
              :traduciendo="trad.traduciendo"
              @alternar="tradAlternar"
              @salida="(c) => tradElegirSalida(c, reservationId)"
              @enviar="tradEnviarLaPrevia"
              @descartar="tradDescartarPrevia"
            />
          </div>
          <div class="ota-input-area">
            <!-- 🔽 Respuestas frecuentes (se abre al escribir "/") -->
            <div v-if="showPredefinedList" class="ota-predefined-dropdown">
              <div class="ota-predefined-header">{{ $t('reservasPanels.ota.predefinedHeader') }}</div>
              <div
                v-for="question in filteredQuestions"
                :key="question.id"
                class="ota-predefined-item"
                @click="selectPredefinedQuestion(question)"
              >
                <div class="ota-predefined-question">{{ question.question }}</div>
                <div v-if="question.answer" class="ota-predefined-answer">{{ question.answer }}</div>
                <img v-if="question.img" :src="question.img" class="ota-predefined-thumb" />
              </div>
              <div v-if="filteredQuestions.length === 0" class="ota-predefined-empty">
                {{ $t('reservasPanels.ota.predefinedEmpty') }}
              </div>
            </div>

            <!-- 📎 Imagen seleccionada (preview) -->
            <div v-if="selectedFilePreview" class="ota-file-preview">
              <img :src="selectedFilePreview" class="ota-file-preview-img" />
              <button class="ota-file-preview-remove" type="button" @click="removeSelectedFile">✕</button>
            </div>

            <BarraTraduccion
              parte="previa"
              :activo="trad.activo"
              :idioma-huesped="trad.idiomaHuesped"
              :nombre-huesped="trad.idiomaHuesped ? tradNombreDe(trad.idiomaHuesped) : ''"
              :mi-idioma-nombre="tradMiIdiomaNombre"
              :salida="tradSalida"
              :opciones="tradOpciones"
              :hay-que-leer="tradHayQueLeer"
              :hay-que-enviar="tradHayQueEnviar"
              :previa="trad.previa"
              :traduciendo="trad.traduciendo"
              @alternar="tradAlternar"
              @salida="(c) => tradElegirSalida(c, reservationId)"
              @enviar="tradEnviarLaPrevia"
              @descartar="tradDescartarPrevia"
            />
            <div class="ota-input-row">
              <input
                ref="fileInput"
                type="file"
                accept="image/*"
                style="display: none"
                @change="onFileSelected"
              />
              <button
                class="ota-attach-btn"
                type="button"
                :title="$t('reservasPanels.ota.attachTitle')"
                :disabled="sending || isChangingMode"
                @click="triggerFileSelect"
              >
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
                </svg>
              </button>
              <textarea
                ref="messageInput"
                v-model="newMessage"
                :disabled="sending || isChangingMode"
                :placeholder="$t('reservasPanels.ota.inputPlaceholder')"
                class="ota-message-input"
                rows="1"
                @keydown.enter.exact.prevent="alPulsarEnterEnLaOta"
              ></textarea>
              <button
                class="ota-send-btn"
                :disabled="sending || isChangingMode || (!newMessage.trim() && !selectedFile)"
                @click="send"
                type="button"
              >
                <svg v-if="!sending" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                </svg>
                  <div v-else class="ota-send-spinner"></div>
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ✅ LIGHTBOX -->
    <div v-if="lightboxUrl" class="ota-lightbox" @click="lightboxUrl = null">
      <img :src="lightboxUrl" class="ota-lightbox-img" />
      <button class="ota-lightbox-close" @click.stop="lightboxUrl = null">
        ✕
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Button from "primevue/button";
import InputSwitch from "primevue/inputswitch";
import MessageTranslate from "@/components/chat/MessageTranslate.vue";
import BarraTraduccion from "@/components/chat/BarraTraduccion.vue";
import traductorDeChat from "@/mixins/traductorDeChat";

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];

export default {
  name: "OtaMessages",
  components: { Button, InputSwitch, MessageTranslate, BarraTraduccion },

  /* El traductor del chat, el mismo de la bandeja y del chat de la reserva: lo
     que escribe el huésped en el hilo de la OTA también hay que entenderlo. */
  mixins: [traductorDeChat],
  props: {
    reservationId: { type: [Number, String], required: true },
    currentChat: { type: Object, default: null },
    channelId: { type: [Number, String], default: null },
    // Listing de la reserva (para cargar las respuestas frecuentes). El padre lo
    // pasa desde reservationData.propiedad.listing_id.
    listingId: { type: [Number, String], default: null },
    // Propiedad de LA RESERVA abierta. Es la que manda para todo lo de Channex
    // (instalar la mensajería, leer y enviar mensajes): el store guarda la
    // propiedad ACTIVA del panel, que casi nunca es la misma.
    reservationProperty: { type: Object, default: null },
  },
  data() {
    return {
      loadingMessages: false,
      messagesAppNotInstalled: false,
      messages: [],
      newMessage: "",
      sending: false,
      installingApp: false,
      isManualMode: false,
      isChangingMode: false,
      threadId: null,
      otaChatInfo: null,
      lightboxUrl: null,
      // Respuestas frecuentes ("/") + adjunto de imagen
      predefinedQuestions: [],
      filteredQuestions: [],
      showPredefinedList: false,
      selectedFile: null,
      selectedFilePreview: null,
    };
  },
  computed: {
    property() {
      // La propiedad de LA RESERVA manda. El store guarda la propiedad "activa"
      // del panel (la del selector de la izquierda), que casi nunca coincide con
      // la de la reserva que se está mirando. Por eso, al instalar la mensajería
      // OTA desde una reserva, a Channex le llegaba el id de OTRA propiedad
      // -siempre el de la primera-: Channex respondía "ya estaba instalada"
      // (cierto, pero de esa otra) y la propiedad del anfitrión no se instalaba
      // nunca; había que entrar a Channex a mano. Medido el 27/08/2026: los 7
      // intentos del día viajaron con el mismo id.
      // El store queda de respaldo por si el padre no pasa la propiedad.
      return this.reservationProperty || this.$store.state.property.property;
    },
    user() {
      return this.$store.state.userRoot;
    },
    // ¿La reserva es de la OTA Booking.com (canal 1)? → fondo mosaico de Booking.
    isBooking() {
      return Number(this.channelId || 0) === 1;
    },
    // ¿La reserva es de la OTA Airbnb (canal 2)? → fondo mosaico de Airbnb.
    isAirbnb() {
      return Number(this.channelId || 0) === 2;
    },
  },
  watch: {
    reservationId: {
      immediate: true,
      async handler(id) {
        /* En qué idioma habla este huésped, para la barra del traductor. */
        this.tradCargarIdioma(id || null);
        await this.fetchOTAChatInfo();
        this.fetchMessages();
        this.fetchPredefinedQuestions();
      },
    },

    /* Lo que llega por la OTA, traído a mi idioma en un solo viaje. */
    messages: {
      deep: true,
      handler(lista) {
        this.tradTraerLoQueFalta(lista, (m) =>
          m && m.sender === "guest" && m.id && m.message
            ? { id: m.id, texto: String(m.message) }
            : null,
        );
      },
    },

    "trad.activo"() {
      this.tradTraerLoQueFalta(this.messages, (m) =>
        m && m.sender === "guest" && m.id && m.message
          ? { id: m.id, texto: String(m.message) }
          : null,
      );
    },
    listingId() {
      this.fetchPredefinedQuestions();
    },
    newMessage(val) {
      this.handlePredefinedQuestionsVisibility(val);
      /* Si se sigue escribiendo, la previa de antes ya no vale. */
      this.tradAlEscribir(val);
    },
    currentChat: {
      immediate: true,
      deep: true,
      handler(chat) {
        if (chat && chat.channel === "ota") {
          this.isManualMode = !(chat.is_active ?? true);
          if (chat.phone_number?.startsWith("CHANNEX_THREAD_")) {
            this.threadId = chat.phone_number;
          }
        }
      },
    },
    otaChatInfo: {
      immediate: true,
      handler(info) {
        if (info) {
          this.threadId = info.phone_number;
          this.isManualMode = !(info.is_active ?? true);
        }
      },
    },
  },
  methods: {
    renderAttachment(att) {
      const url = this.buildAttachmentUrl(att);
      const name = this.getFileName(url);
      if (this.isImage(att)) {
        return `<img
      src="${url}"
      alt="${name}"
      class="ota-img"
      style="cursor:pointer"
      onerror="this.style.display='none';this.nextSibling.style.display='inline'"
    /><a href="${url}" target="_blank" rel="noopener" class="ota-file-link" style="display:none">📎 ${name}</a>`;
      }
      return `<a href="${url}" target="_blank" rel="noopener" class="ota-file-link">📎 ${name}</a>`;
    },

    handleAttachmentClick(att) {
      if (this.isImage(att)) {
        this.lightboxUrl = this.buildAttachmentUrl(att);
      }
    },
    async fetchOTAChatInfo() {
      if (!this.reservationId || !this.property) return;
      try {
        const { data } = await axios.get(
          `/reservations/${this.reservationId}/ota-chat-info`,
          { params: { property_id: this.property.id } },
        );
        if (data.success && data.chat) this.otaChatInfo = data.chat;
      } catch (error) {
        console.error("❌ Error obteniendo info del chat OTA:", error);
      }
    },

    async fetchMessages() {
      if (!this.reservationId) return;
      this.loadingMessages = true;
      this.messagesAppNotInstalled = false;

      try {
        const { data } = await axios.get(
          `/reservations/${this.reservationId}/channex/messages`,
        );

        // Sin mensajes o sin hilo todavía: el panel ya lo dice por dentro
        // («No hay mensajes OTA para esta reserva»), así que no se saca un
        // aviso encima. Abrir una reserva de OTA es lo más normal del mundo y
        // saltaba un error rojo cada vez.
        if (!data.success) {
          console.warn("[OTA] respuesta sin mensajes", data.message || "");
          this.messages = [];
          return;
        }

        if (data.data?.thread_id && !this.threadId) {
          this.threadId = data.data.thread_id;
          await this.fetchOTAChatInfo();
        }

        const raw = data.data?.messages || [];
        this.messages = raw
          .slice()
          .sort((a, b) => new Date(a.inserted_at) - new Date(b.inserted_at));

        this.$nextTick(() => this.scrollToBottom());
      } catch (error) {
        if (error.response?.status === 403) {
          this.messagesAppNotInstalled = true;
        } else {
          // Tampoco aquí: si la consulta falla, el panel se queda con su
          // mensaje de «no hay mensajes» y el fallo queda en la consola. Un
          // error rojo al abrir cada reserva de OTA solo es ruido.
          console.error("[OTA] no se pudieron cargar los mensajes", error);
          this.messages = [];
        }
      } finally {
        this.loadingMessages = false;
      }
    },

    async handleModeChange() {
      // v-model="isManualMode" ya está actualizado ANTES de @change. NO usar el arg:
      // PrimeVue pasa un Event DOM ({isTrusted:true}) → el backend recibía manual_mode
      // no-booleano y respondía validation.boolean (revertía a automático).
      const value = this.isManualMode === true;

      if (!this.threadId || !this.property || !this.reservationId) {
        this.$toast?.add({
          severity: "error",
          summary: this.$t("reservasPanels.ota.errorTitle"),
          detail: this.$t("reservasPanels.ota.modeErrorDetail"),
          life: 3000,
        });
        this.$nextTick(() => {
          this.isManualMode = !value;
        });
        return;
      }

      this.isChangingMode = true;
      try {
        const { data } = await axios.post("/toggle-ota-chat-mode", {
          thread_id: this.threadId,
          property_id: this.property.id,
          reservation_id: this.reservationId,
          manual_mode: value,
        });

        if (data.success) {
          if (this.currentChat)
            this.$set(this.currentChat, "is_active", !value);
          if (this.otaChatInfo) this.otaChatInfo.is_active = !value;

          this.$toast?.add({
            severity: "success",
            summary: value ? this.$t("reservasPanels.ota.modeManualOnTitle") : this.$t("reservasPanels.ota.modeAiOnTitle"),
            detail: value
              ? this.$t("reservasPanels.ota.modeManualOnDetail")
              : this.$t("reservasPanels.ota.modeAiOnDetail"),
            life: 3000,
          });
        }
      } catch (error) {
        console.error("❌ Error cambiando modo OTA:", error);
        this.$nextTick(() => {
          this.isManualMode = !value;
        });
        this.$toast?.add({
          severity: "error",
          summary: this.$t("reservasPanels.ota.errorTitle"),
          detail: this.$t("reservasPanels.ota.modeChangeError"),
          life: 3000,
        });
      } finally {
        this.isChangingMode = false;
      }
    },

    /**
     * El Enter del hilo de la OTA. Con el traductor encendido y un huésped que
     * habla otro idioma, el primero enseña cómo le va a llegar; el segundo lo
     * manda ya traducido.
     */
    alPulsarEnterEnLaOta() {
      const loLleva = this.tradAlPulsarEnter(this.newMessage, this.reservationId, (traducido) => {
        this.newMessage = traducido;
        this.$nextTick(() => this.send());
      });
      if (!loLleva) this.send();
    },

    /** Manda lo que se ha previsualizado, desde el botón de la barra. */
    tradEnviarLaPrevia() {
      const previa = this.trad.previa;
      if (!previa) return;
      this.trad.previa = null;
      this.newMessage = previa.texto;
      this.$nextTick(() => this.send());
    },

    async send() {
      const content = this.newMessage.trim();
      // Permitir enviar solo-imagen, solo-texto o ambos.
      if (this.sending || (!content && !this.selectedFile)) return;
      this.sending = true;
      try {
        let response;
        if (this.selectedFile) {
          // Con adjunto → multipart. El backend acepta 'file' (solo imágenes en OTA)
          // y genera un mensaje de adjunto + otro de texto si hay.
          const formData = new FormData();
          if (content) formData.append("message", content);
          formData.append("file", this.selectedFile);
          response = await axios.post(
            `/reservations/${this.reservationId}/channex/messages`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
          );
        } else {
          response = await axios.post(
            `/reservations/${this.reservationId}/channex/messages`,
            { message: content },
          );
        }
        if (!response.data.success)
          throw new Error(response.data.message || "Send failed");
        this.newMessage = "";
        this.removeSelectedFile();
        this.showPredefinedList = false;
        this.filteredQuestions = [];
        await this.fetchMessages();
      } catch (error) {
        console.error("Error sending OTA message", error);
        this.$toast?.add({
          severity: "error",
          summary: this.$t("reservasPanels.ota.errorTitle"),
          detail: this.$t("reservasPanels.ota.sendError"),
          life: 3000,
        });
      } finally {
        this.sending = false;
      }
    },

    // ── Respuestas frecuentes ("/") ──────────────────────────────────────────
    async fetchPredefinedQuestions() {
      // El listing se pasa como prop desde la reserva; con fallback al store por
      // si el padre no lo pasó. En la vista de reserva el store puede no tener la
      // propiedad correcta, por eso la prop es la fuente principal.
      const listingId =
        this.listingId ||
        this.currentChat?.property?.listing_id ||
        this.$store.state.property?.property?.listing_id ||
        null;

      if (!listingId) return;

      try {
        const { data } = await axios.get(
          `/retrive/waba/${listingId}/bot-config-question`,
        );
        this.predefinedQuestions = (data || []).map((question) => {
          const files = Array.isArray(question.files) ? question.files : [];
          const firstImg = files
            .map((f) => this.resolvePredefinedFileUrl(f))
            .find((u) => u && /\.(jpe?g|png|gif|webp|bmp)$/i.test(u.split("?")[0]));
          return { ...question, files, img: firstImg || null };
        });
      } catch (error) {
        console.error("Error al cargar respuestas frecuentes:", error);
      }
    },

    resolvePredefinedFileUrl(file) {
      if (!file) return "";
      const backendBase = String(
        process.env.VUE_APP_API_SERVER_BACKEND || window.location.origin,
      ).replace(/\/+$/, "");
      return (
        file.public_url ||
        file.url ||
        (file.file_path
          ? `${backendBase}/storage/${String(file.file_path).replace(/^storage\//, "")}`
          : "")
      );
    },

    handlePredefinedQuestionsVisibility(text) {
      // Solo en modo manual (si el bot está activo no se responde a mano).
      if (!this.isManualMode || !String(text || "").startsWith("/")) {
        this.showPredefinedList = false;
        this.filteredQuestions = [];
        return;
      }

      const searchText = String(text || "").slice(1).toLowerCase().trim();
      this.filteredQuestions = searchText === ""
        ? this.predefinedQuestions
        : this.predefinedQuestions.filter((q) =>
            String(q.question || "").toLowerCase().includes(searchText),
          );

      this.showPredefinedList = true;
    },

    async selectPredefinedQuestion(question) {
      this.newMessage = question.answer || "";
      this.showPredefinedList = false;
      this.filteredQuestions = [];

      // Si la respuesta trae imagen y no hay adjunto manual, intentamos adjuntarla
      // (best-effort: si falla la descarga, se envía solo el texto).
      if (question.img && !this.selectedFile) {
        try {
          const res = await fetch(question.img);
          const blob = await res.blob();
          if (blob.type.startsWith("image/")) {
            const name = (question.img.split("/").pop() || "faq-image").split("?")[0];
            this.setSelectedFile(new File([blob], name, { type: blob.type }));
          }
        } catch (e) {
          /* silencioso: se envía solo el texto */
        }
      }

      this.$nextTick(() => this.$refs.messageInput?.focus());
    },

    // ── Adjunto de imagen ────────────────────────────────────────────────────
    triggerFileSelect() {
      this.$refs.fileInput?.click();
    },

    onFileSelected(event) {
      const file = (event.target.files || [])[0];
      if (this.$refs.fileInput) this.$refs.fileInput.value = "";
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        this.$toast?.add({
          severity: "warn",
          summary: this.$t("reservasPanels.ota.onlyImagesTitle"),
          detail: this.$t("reservasPanels.ota.onlyImagesDetail"),
          life: 3000,
        });
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        this.$toast?.add({
          severity: "warn",
          summary: this.$t("reservasPanels.ota.imageTooBigTitle"),
          detail: this.$t("reservasPanels.ota.imageTooBigDetail"),
          life: 3000,
        });
        return;
      }
      this.setSelectedFile(file);
    },

    setSelectedFile(file) {
      this.removeSelectedFile();
      this.selectedFile = file;
      this.selectedFilePreview = URL.createObjectURL(file);
    },

    removeSelectedFile() {
      if (this.selectedFilePreview) URL.revokeObjectURL(this.selectedFilePreview);
      this.selectedFile = null;
      this.selectedFilePreview = null;
    },

    // ✅ Detecta imagen por extensión
    isImage(att) {
      const url = this.buildAttachmentUrl(att);
      const clean = url.split("?")[0].split("#")[0].toLowerCase();
      const ext = clean.split(".").pop();
      return IMAGE_EXTENSIONS.includes(ext);
    },

    openImage(url) {
      this.lightboxUrl = url;
    },

    // ✅ Si imagen falla (auth), convierte a link
    onImageError(event, att) {
      const url = this.buildAttachmentUrl(att);
      const parent = event.target.closest(".ota-image-preview");
      if (parent) {
        parent.innerHTML = `<a href="${url}" target="_blank" rel="noopener" class="ota-file-link">📎 ${this.getFileName(
          url,
        )}</a>`;
      }
    },

    buildAttachmentUrl(att) {
      if (!att) return "#";
      // Forzar https: Channex sirve las URLs en http:// y el navegador las bloquea
      // (mixed content). El backend ya persiste copia propia, pero por si acaso.
      const toHttps = (u) =>
        typeof u === "string" ? u.replace(/^http:\/\//i, "https://") : u;
      if (typeof att === "string" && att.startsWith("http")) return toHttps(att);
      if (att.url?.startsWith("http")) return toHttps(att.url);
      const path =
        typeof att === "string" ? att : att.url || att.path || att.href || "";
      /*
       * De dónde se bajan los adjuntos. Iba a `MIX_CHANNEX_ATTACH_BASE_URL`,
       * que vue-cli NO expone —sólo inyecta las `VUE_APP_*`—, así que esa
       * variable era SIEMPRE undefined y caía al valor de reserva: en beta los
       * adjuntos se pedían a Channex de PRODUCCIÓN. Se saca de la misma variable
       * que ya usa el resto de la casa: en beta apunta a staging y en producción
       * a app.channex.io.
       */
      const raiz = (process.env.VUE_APP_API_CHANNEX || "https://app.channex.io")
        .replace(/\/+$/, "");
      const base = `${raiz}/api/v1`;
      return toHttps(`${base}${path.startsWith("/") ? "" : "/"}${path}`);
    },

    getFileName(url) {
      if (!url) return this.$t("reservasPanels.ota.fileFallback");
      return (
        url.toString().split("?")[0].split("#")[0].split("/").pop() || this.$t("reservasPanels.ota.fileFallback")
      );
    },

    formatSender(sender) {
      if (sender === "guest") return this.$t("reservasPanels.ota.senderGuest");
      if (sender === "property") return this.$t("reservasPanels.ota.senderProperty");
      if (sender === "system") return this.$t("reservasPanels.ota.senderSystem");
      return sender || this.$t("reservasPanels.ota.senderUnknown");
    },

    formatDate(ts) {
      return ts ? moment(ts).format("DD/MM/YYYY HH:mm") : "";
    },

    scrollToBottom() {
      const el = this.$refs.otaContainer;
      if (el) el.scrollTop = el.scrollHeight;
    },

    async installMessagesApp() {
      if (!this.property?.id_property_channel) {
        this.$toast?.add({
          severity: "warn",
          summary: this.$t("reservasPanels.ota.toastTitle"),
          detail: this.$t("reservasPanels.ota.installNoProperty"),
          life: 4000,
        });
        return;
      }
      this.installingApp = true;
      try {
        const response = await axios.post(`/channex/install-application`, {
          id_property_channel: this.property.id_property_channel,
          user_id: this.user?.id,
        });
        this.$toast?.add({
          severity: "success",
          summary: this.$t("reservasPanels.ota.toastTitle"),
          detail:
            response.data?.message || this.$t("reservasPanels.ota.installOk"),
          life: 4000,
        });
        this.messagesAppNotInstalled = false;
        await this.fetchMessages();
      } catch (error) {
        console.error("Error instalando app de mensajes Channex:", error);
        this.$toast?.add({
          severity: "error",
          summary: this.$t("reservasPanels.ota.toastTitle"),
          detail:
            error.response?.data?.error || this.$t("reservasPanels.ota.installError"),
          life: 5000,
        });
      } finally {
        this.installingApp = false;
      }
    },

    retryAfterInstall() {
      this.messagesAppNotInstalled = false;
      this.fetchMessages();
    },
  },
};
</script>

<style scoped>




.ota-app-card {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 18px 20px;
  border-radius: 16px;
  border: 1px solid #e5e7eb;
  background: #fafafa;
  box-shadow: 0px 0px 32px 3px #eee;
  width: 80%;
  margin: auto;
}
.ota-app-content {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}
.ota-app-text {
  flex: 1;
}
.ota-app-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #111827;
}
.ota-app-subtitle {
  margin-top: 4px;
  margin-bottom: 10px;
  font-size: 0.9rem;
  color: #4b5563;
}
.ota-app-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.ota-app-main-btn {
  min-width: 260px;
}
.ota-app-link {
  border: none;
  background: transparent;
  padding: 0;
  font-size: 0.8rem;
  color: #2563eb;
  text-decoration: underline;
  cursor: pointer;
}

.ota-chat-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.ota-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  font-size: 0.88rem;
  color: #6b7280;
  padding: 40px 0;
}

.ota-chat {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* ✅ SCROLL FIJO - clave para que no se estire */
.ota-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px 12px 12px;
  min-height: 0;
}

/* Reserva de la OTA Booking → fondo mosaico de Booking */
.ota-messages--booking {
  background-color: #f4f8fd;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)),
    url("~@/assets/fondo_booking_chat.svg");
  background-repeat: no-repeat, repeat;
  background-size: 100% 100%, 320px auto;
  background-attachment: local, local;
}

/* Reserva de la OTA Airbnb → fondo mosaico de Airbnb */
.ota-messages--airbnb {
  background-color: #fdf1f2;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.55), rgba(255, 255, 255, 0.55)),
    url("~@/assets/fondo_airbnb_chat.svg");
  background-repeat: no-repeat, repeat;
  background-size: 100% 100%, 320px auto;
  background-attachment: local, local;
}

.ota-empty {
  font-size: 0.88rem;
  color: #9ca3af;
  text-align: center;
  padding-top: 40px;
}

.ota-message-row {
  margin-bottom: 8px;
  display: flex;
}
.ota-message-row.guest {
  justify-content: flex-start;
}
.ota-message-row.property,
.ota-message-row.system {
  justify-content: flex-end;
}

.ota-message-card {
  max-width: 70%;
  border-radius: 14px;
  padding: 8px 10px;
  background: #ffffff;
  box-shadow: 0 3px 10px rgba(148, 163, 184, 0.35);
  font-size: 0.86rem;
  margin: 2px 0;
}
.ota-message-card.guest {
  background: #e0f2fe;
}
.ota-message-card.property {
  background: #eef2ff;
}

.ota-message-text {
  color: #111827;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ota-attachments {
  margin-top: 6px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.ota-attachment-item {
  display: flex;
  flex-direction: column;
}

.ota-image-preview {
  cursor: pointer;
}
.ota-img {
  max-width: 140px;
  max-height: 100px;
  border-radius: 10px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
  display: block;
  transition: opacity 0.2s;
}
.ota-img:hover {
  opacity: 0.88;
}

.ota-file-link {
  font-size: 0.78rem;
  color: #1d4ed8;
  text-decoration: none;
}

.ota-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 0.7rem;
  color: #6b7280;
  gap: 12px;
}

/* ✅ FOOTER FIJO */
.ota-footer {
  flex-shrink: 0;
  border-top: 1px solid #e5e7eb;
  padding: 12px 16px 10px;
  background: #f9fafb;
}

.mode-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  padding: 10px 14px;
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}
.mode-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.875rem;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
}
.mode-label.active {
  color: #3b82f6;
  font-weight: 600;
}

.ai-agent-icon {
  width: 20px;
  height: 20px;
  color: currentColor;
  fill: none;
  flex-shrink: 0;
}

.ai-agent-icon--sm {
  width: 16px;
  height: 16px;
}
.custom-switch {
  flex-shrink: 0;
}

.ota-input-area {
  position: relative;
  border-radius: 14px;
  padding: 8px 10px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 2px 8px rgba(148, 163, 184, 0.12);
}

/* Respuestas frecuentes ("/") */
.ota-predefined-dropdown {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(100% + 6px);
  max-height: 280px;
  overflow-y: auto;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(16, 24, 40, 0.12);
  z-index: 20;
}
.ota-predefined-header {
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #94a3b8;
  border-bottom: 1px solid #f1f5f9;
}
.ota-predefined-item {
  padding: 10px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.12s ease;
}
.ota-predefined-item:last-child { border-bottom: none; }
.ota-predefined-item:hover { background: #f5f7ff; }
.ota-predefined-question {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}
.ota-predefined-answer {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ota-predefined-thumb {
  margin-top: 6px;
  max-height: 46px;
  border-radius: 6px;
}
.ota-predefined-empty {
  padding: 12px;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}

/* Preview de imagen adjunta */
.ota-file-preview {
  position: relative;
  display: inline-block;
  margin-bottom: 8px;
}
.ota-file-preview-img {
  max-height: 72px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  display: block;
}
.ota-file-preview-remove {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: #ef4444;
  color: #fff;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Botón adjuntar */
.ota-attach-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: #f1f5f9;
  color: #475569;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease;
}
.ota-attach-btn:hover:not(:disabled) { background: #e2e8f0; }
.ota-attach-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.ota-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ota-message-input {
  flex: 1;
  min-height: 32px;
  max-height: 120px;
  border: none;
  outline: none;
  resize: none;
  font-size: 0.9rem;
  font-family: inherit;
  color: #111827;
  background: transparent;
  line-height: 1.5;
  padding: 4px 0;
}
.ota-message-input::placeholder {
  color: #9ca3af;
}

.ota-send-btn {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: #3b82f6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.2s ease;
}
.ota-send-btn:hover:not(:disabled) {
  background: #2563eb;
  transform: translateY(-1px);
}
.ota-send-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ota-send-spinner {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  animation: ota-spin 0.7s linear infinite;
}
@keyframes ota-spin {
  to {
    transform: rotate(360deg);
  }
}

/* ✅ LIGHTBOX */
.ota-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  cursor: zoom-out;
}
.ota-lightbox-img {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 12px;
  object-fit: contain;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
}
.ota-lightbox-close {
  position: absolute;
  top: 18px;
  right: 22px;
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  font-size: 1.3rem;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ota-lightbox-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .ota-app-card {
    padding: 14px;
  }
  .ota-message-card {
    max-width: 85%;
  }
  .ota-img {
    max-width: 120px;
    max-height: 90px;
  }
  .ota-message-input {
    font-size: 0.86rem;
  }
  .mode-label {
    font-size: 0.8rem;
  }
}

/* Asegura que el wrapper tenga altura del contenedor padre */
.ota-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  position: relative;
}

.ota-chat-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;        /* ← CLAVE en flex */
  overflow: hidden;
}

.ota-chat {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;        /* ← CLAVE en flex */
  overflow: hidden;
}

.ota-messages {
  flex: 1;
  overflow-y: auto;
  padding: 10px 12px 12px;
  min-height: 0;        /* ← CLAVE en flex */
}


</style>
<style>
/* Estilos globales para contenido dinámico v-html */
.ota-attachment-item img.ota-img {
  max-width: 130px !important;
  max-height: 100px !important;
  border-radius: 10px;
  object-fit: cover;
  border: 1px solid #e5e7eb;
  display: block;
  transition: opacity 0.2s;
  cursor: pointer;
}
.ota-attachment-item img.ota-img:hover {
  opacity: 0.88;
}
.ota-attachment-item a.ota-file-link {
  font-size: 0.78rem;
  color: #1d4ed8;
  text-decoration: none;
}

@media (max-width: 768px) {
  .ota-attachment-item img.ota-img {
    max-width: 120px;
    max-height: 90px;
  }
}
</style>
